export default __webpack_public_path__ + "static/media/bg-chat.b8ab0e7c.png";